import { Component, OnInit, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslationLoaderService } from '../service/translation-loader.service';
import { DOC_URL, SHOW_HELP, SHOW_CGU } from '../lumilogin.token';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
	
	public year: number;
	public docUrl: string = "";
	public showHelp: boolean = false;
	public showCGU: boolean = false;

  constructor(private _translateService: TranslateService,
		public _translationLoaderService: TranslationLoaderService,
		@Inject(DOC_URL) private doc_url: string,
		@Inject(SHOW_HELP) private show_help: boolean,
		@Inject(SHOW_CGU) private show_cgu: boolean) {
			this.docUrl = doc_url;
			this.showHelp = show_help;
			this.showCGU = show_cgu;
	}

  ngOnInit() {
		this.year = new Date().getFullYear();
  }

}
